// https://github.com/DavidWells/analytics#creating-analytics-plugins

import { HttpClient } from '@angular/common/http'
import { AnalyticsPlugin } from 'analytics'
import { timer } from 'rxjs'

import {
  TrackingAnalyticsIdentifyTraits,
  TrackingEventEnum,
} from './tracking.service'

export interface HunterApiConfig {
  httpClient: HttpClient
  hunterApiUrl: string
}

class HunterAnalyticsPlugin implements AnalyticsPlugin {
  [x: string]: unknown
  public name = 'hunter'

  constructor(public config: HunterApiConfig) {}
  EVENTS?: any
  initialize?: (...params: any[]) => any
  ready?: (...params: any[]) => any

  private identifyTime: Date
  private user: TrackingAnalyticsIdentifyTraits

  private sendTrackingRequest = (
    event: TrackingEventEnum,
    data: object,
  ): void => {
    if (this.user) {
      this.config.httpClient
        .post(
          `${this.config.hunterApiUrl}/v2/tracking/event`,
          {
            name: event,
            data,
          },
          { responseType: 'blob', observe: 'response' },
        )
        .subscribe()
    }
  }

  // call provider specific page tracking
  public page = (): void => {
    this.logTimeInApp()
  }

  // call provider specific event tracking
  public track = ({
    payload,
  }: {
    payload: { event: TrackingEventEnum; properties: object }
  }): void => {
    this.sendTrackingRequest(payload.event, payload.properties)
  }

  // call provider specific user identify method
  public identify = ({
    payload,
  }: {
    payload: { traits: TrackingAnalyticsIdentifyTraits }
  }): void => {
    this.user = payload.traits
    this.identifyTime = new Date()

    timer(60000).subscribe(() => {
      this.logTimeInApp()
    })
  }

  // return boolean so analytics knows when it can send data to third-party
  public loaded = (): boolean => {
    return true
  }

  private logTimeInApp = (): void => {
    if (this.identifyTime) {
      const endDate = new Date()
      this.sendTrackingRequest(TrackingEventEnum.AUTH_TIME_IN_APP, {
        startDate: this.identifyTime.toISOString(),
        endDate: endDate.toISOString(),
        ms: endDate.getTime() - this.identifyTime.getTime(),
      })
    }
  }
}

export function hunterApiPlugin(config: HunterApiConfig): AnalyticsPlugin {
  return new HunterAnalyticsPlugin(config)
}
